import { FormBuilder, Validators } from '@angular/forms';
import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService, } from '../../services/application/application.service';
import { AuthService } from '../../services/authentication/auth.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService, DownloadFormat, HttpMethod } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { TitleCasePipe } from '../../pipes/titlecase.pipe';
import { validateEmail } from '../../validators/email.validator';
var ManageStaffComponent = /** @class */ (function () {
    function ManageStaffComponent(appService, authService, dialogService, downloadService, errorService, fb, mediaChange, splashService, titleCasePipe, userService) {
        this.appService = appService;
        this.authService = authService;
        this.dialogService = dialogService;
        this.downloadService = downloadService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.titleCasePipe = titleCasePipe;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['FirstName', 'LastName', 'AccessLevel', 'StaffActions'];
        this.parentErrorStateMatcher = new ParentErrorStateMatcher();
    }
    ManageStaffComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AdminCollege = null;
        self.StaffData = new DataTableSource([], self.paginator, self.sorter, self.SortStaff.bind(self));
        self.StaffList = null;
        self.Colleges = null;
        self.NewUserForm = null;
        self.NoData = false;
        self.PartialViewReady = false;
        self.ShowingNewUserForm = false;
        self.SmallDisplay = false;
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Make an empty new user form
        self.NewUserForm = self.fb.group({
            FirstName: [null, Validators.required],
            LastName: [null, Validators.required],
            Email: [null, [Validators.required, validateEmail]],
            EmailVerify: [null, [Validators.required, validateEmail]],
        }, { validator: self.EmailVerifyValidator });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load static data for use in the compoment.
            combineLatest(self.appService.GetAllColleges(self.User.AuthToken), self.appService.GetAllCollegeYears(), self.appService.SelectedAdminCollegeIDSubject, function (colleges, collegeyears, adminCollegeID) {
                return {
                    AdminCollegeID: adminCollegeID,
                    Colleges: colleges,
                    CollegeYears: collegeyears,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.Colleges = packet.Colleges;
                self.AllCollegeYears = packet.CollegeYears;
                self.AdminCollegeID = packet.AdminCollegeID;
                self.AdminCollege = null;
                if (self.AdminCollegeID != null && self.Colleges) {
                    self.AdminCollege = self.Colleges.find(function (item) {
                        return item.CollegeID === self.AdminCollegeID;
                    });
                }
                // Load the staff for this college, if one has been selected.
                if (self.AdminCollege) {
                    self.appService.GetAllCollegeStaffForCollege(self.User.AuthToken, self.AdminCollege.CollegeID).subscribe(function (staff) {
                        self.UpdateStaff(staff);
                        // Ready for component use.
                        self.PartialViewReady = true;
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                }
                else {
                    // No college selected. Release component for viewing.
                    self.PartialViewReady = true;
                }
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    ManageStaffComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Add New User Method
    ManageStaffComponent.prototype.AddNewUser = function (collegerole) {
        var self = this;
        if (collegerole == null) {
            return;
        }
        var form = self.NewUserForm.value;
        var levelName = collegerole === 2 ? 'Administrator' : collegerole === 1 ? 'Advisor' : 'Support Staff';
        // Get the user confirmation before proceeding.
        var message = "You are about to create a new user account as a college staff member for the following " +
            ("individual and college:<br /><br /><strong>First Name: </strong>" + self.titleCasePipe.transform(form.FirstName) + "<br />") +
            ("<strong>Last Name: </strong>" + self.titleCasePipe.transform(form.LastName) + "<br />") +
            ("<strong>Email Address: </strong>" + form.Email + "<br /><strong>College: </strong>" + self.AdminCollege.CollegeName + "<br />") +
            ("<strong>Role: </strong>" + levelName + "<br /><br />Once the new user account is created, you will be given the ") +
            "username and randomly generated password for the new account, and the user will be sent an introduction email " +
            "with directions on how to change their password and access the DELTA System. Are you sure you wish to add the " +
            "new user account as summarized above?";
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: "Yes - Add New " + levelName + " Account",
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (success) {
            if (success === true) {
                // Add new user account
                self.splashService
                    .DisplaySplash({
                    TitleText: 'Please Wait',
                    MessageText: 'Creating user account...',
                })
                    .subscribe(function () {
                    self.authService
                        .AddNewUser(self.User.AuthToken, self.User.CurrentRole, form.FirstName, form.LastName, form.Email, self.AdminCollege.CollegeID, collegerole)
                        .subscribe(function (user) {
                        self.splashService.CloseSplash();
                        // Was the result returned a new account? If not, then the email address matched an existing one.
                        // Show a dialog in that case to the system user.
                        if (!user.NewAccount) {
                            // Show the dialog
                            self.dialogService.OpenMessageBoxDialog({
                                TitleText: 'Duplicate Email Address Detected',
                                MessageText: "The email address provided (" + form.Email + ") is already attached to an " +
                                    "existing account. The existing account information is provided below:<br /><br />" +
                                    ("<strong>Username: </strong>" + user.Username + "<br /><strong>User ID#: </strong>") +
                                    (user.UserID + "<br /><strong>First Name: </strong>" + user.FirstName + "<br />") +
                                    ("<strong>Last Name: </strong>" + user.LastName + "<br />") +
                                    ("<strong>Email: </strong>" + user.Email + "<br /><br />You cannot create a new ") +
                                    "account using this email address. If the information above looks " +
                                    "appropriate for the desired user, you may provide them with the username " +
                                    "shown above.",
                                OKText: 'OK',
                            });
                            var input = document.querySelector('.firstname');
                            input.focus();
                            return;
                        }
                        else {
                            // Reset and close the form
                            self.NewUserForm.reset();
                            self.ShowingNewUserForm = false;
                            // Update the listed staff with the returned packet (if available)
                            self.UpdateStaff(user.Staff);
                            // Display the created account information
                            self.splashService.SnackbarSuccess('New User Created Successfully.');
                            var msg2 = "The following user account was created:<br /><br />\n                                        <strong>Username: </strong>" + user.Username + "<br />\n                                        <strong>Password: </strong>" + user.Password + "<br />\n                                        <strong>Email: </strong>" + user.Email + "<br />\n                                        <strong>Polk User ID#: </strong>" + user.UserID + "<br />\n                                        <strong>College: </strong>" + user.CollegeName + "<br />\n                                        <strong>Role: </strong>" + user.RoleName + "<br /><br />This user has had an email sent " +
                                "to the provided email address above with instructions on how to reset their default " +
                                "password and access the DELTA System.";
                            self.dialogService
                                .OpenMessageBoxDialog({
                                TitleText: 'New User Account Information',
                                MessageText: msg2,
                                OKText: 'OK',
                            })
                                .subscribe();
                        }
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                });
            }
        });
    };
    // #endregion
    // #region Change Access Method
    ManageStaffComponent.prototype.ChangeAccess = function (user) {
        var self = this;
        if (!user) {
            return;
        }
        var levelName = user.AccessLevel === 2 ? 'Administrator' : user.AccessLevel === 1 ? 'Advisor' : 'Support staff';
        var message = "You have chosen to change the college staff member access for the following user:<br /><br />" +
            ("<strong>First Name: </strong>" + self.titleCasePipe.transform(user.FirstName) + "<br />") +
            ("<strong>Last Name: </strong>" + self.titleCasePipe.transform(user.LastName) + "<br />") +
            ("<strong>College: </strong>" + self.AdminCollege.CollegeName + "<br />") +
            ("<strong>Current Level: </strong>" + levelName + "<br /><br />") +
            "Select a new level by clicking on the appropriate button below. If you wish to cancel this request," +
            " click the \"Cancel\" button at this time.";
        var adminOption = {
            DisplayText: 'Change to Administrator',
            Response: 2,
            ClosesDialog: true,
            Color: 'warn',
        };
        var advisorOption = {
            DisplayText: 'Change to Advisor',
            Response: 1,
            ClosesDialog: true,
            Color: 'accent',
        };
        var supportOption = {
            DisplayText: 'Change to Support',
            Response: 0,
            ClosesDialog: true,
            Color: 'primary',
        };
        var options = [];
        if (user.AccessLevel === 2) {
            // Push in options for advisor and support
            options.push(advisorOption, supportOption);
        }
        else if (user.AccessLevel === 1) {
            // Push in options for administrator and support
            options.push(adminOption, supportOption);
        }
        else {
            // Push in options for administrator and advisor
            options.push(adminOption, advisorOption);
        }
        // Add a cancel button
        options.unshift({ Response: null, DisplayText: 'Cancel', ClosesDialog: true, Color: 'warn' });
        // Get a confirmation and the desired change option for this employee.
        self.dialogService
            .OpenOptionBoxDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: 'Yes - Remove',
            CancelText: 'No - CANCEL',
            Options: options,
        })
            .subscribe(function (result) {
            if (result != null) {
                // User has opted to proceed. Signal the system to change the access level for this person based upon what
                // was just selected.
                self.appService
                    .UpdateCollegeStaffAccessLevel(self.User.AuthToken, self.User.CurrentRole, user.StaffID, result)
                    .subscribe(function (staff) {
                    // Completed. Refresh the list of staff from what was just returned.
                    self.UpdateStaff(staff);
                    // Toast the success
                    var newLevelName = result === 2 ? 'administrator' : result === 1 ? 'advisor' : 'support staff';
                    self.splashService.SnackbarSuccess("User access changed to " + newLevelName + " successfully.");
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Download Staff PDF Method
    ManageStaffComponent.prototype.DownloadStaffPDF = function () {
        var self = this;
        // Set splash
        self.splashService
            .DisplaySplash({
            TitleText: 'Please wait',
            MessageText: 'Downloading College Staff PDF...',
        })
            .pipe(takeUntil(self._subrelease))
            .subscribe(function () {
            self.downloadService
                .RetrieveDownload(HttpMethod.GET, "Api/Services/PDF/PDFDownloadStaffList", {
                AuthToken: self.User.AuthToken,
                CollegeID: self.AdminCollege.CollegeID,
                Attachment: true,
            }, DownloadFormat.PDF)
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (success) {
                // Drop the splash?
                self.splashService.CloseSplash();
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    // #endregion
    // #region Email Verify Validate Method
    ManageStaffComponent.prototype.EmailVerifyValidator = function (grp) {
        var gval = grp.value;
        if (gval.Email !== gval.EmailVerify) {
            return {
                EmailVerifyValidate: 'mismatch',
            };
        }
        return null;
    };
    // #endregion
    // #region Remove Access Method
    ManageStaffComponent.prototype.RemoveAccess = function (user) {
        var self = this;
        if (!user) {
            return;
        }
        var levelName = user.AccessLevel === 2 ? 'administrator' : user.AccessLevel === 1 ? 'advisor' : 'support staff';
        var message = "You have chosen to remove the following user as a(n) " + levelName + " for " + self.AdminCollege.CollegeName + "<br /><br />\n        <strong>First Name: </strong>" + self.titleCasePipe.transform(user.FirstName) + "<br />\n        <strong>Last Name: </strong>" + self.titleCasePipe.transform(user.LastName) + "<br /><br />\n        Once removed, this user will no longer have " + levelName + " access to this college. If this person is no longer " +
            "a college staff member for any other college, they will no longer have college access to the DELTA system after this " +
            "process completes. Are you sure you wish to continue?";
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: 'Yes - Remove',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result != null) {
                // User has opted to proceed. Signal the system to remove this person entirely from the system.
                self.appService.RemoveCollegeStaffFromCollege(self.User.AuthToken, user.StaffID).subscribe(function (staff) {
                    // Completed. Refresh the list of staff from what was just returned.
                    self.UpdateStaff(staff);
                    // Toast the success
                    self.splashService.SnackbarSuccess("User was removed as a(n) " + levelName + " successfully.");
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Reset New User Form Method
    ManageStaffComponent.prototype.ResetNewUserForm = function () {
        this.NewUserForm.reset();
        this.ShowingNewUserForm = false;
    };
    // #endregion
    // #region Show New User Form Method
    ManageStaffComponent.prototype.ShowNewUserForm = function () {
        this.ShowingNewUserForm = !this.ShowingNewUserForm;
    };
    // #endregion
    // #region Show User Search Method
    ManageStaffComponent.prototype.ShowUserSearch = function () {
        var self = this;
        // Pop up a user search dialog.
        self.dialogService
            .OpenUserSearchDialog({
            TitleText: 'DELTA User Search',
            MessageText: "Use the following options to search for a DELTA user:",
            CanAddAsAdministrator: true,
        })
            .subscribe(function (chosenUser) {
            if (chosenUser != null) {
                // Get a confirmation on adding this user as an advisor/administrator.
                var levelName_1 = chosenUser.AccessLevel === 2 ? 'administrator' : chosenUser.AccessLevel === 1 ? 'advisor' : 'support staff';
                self.dialogService
                    .OpenConfirmationDialog({
                    TitleText: 'Confirmation Requested',
                    MessageText: "You are about to add the following user as an <strong>" + levelName_1 + "</strong> " +
                        "for this college:</div><br />" +
                        ("<div><strong>First name: </strong>" + self.titleCasePipe.transform(chosenUser.User.FirstName) + "</div>") +
                        ("<div><strong>Last name: </strong>" + self.titleCasePipe.transform(chosenUser.User.LastName) + "</div>") +
                        ("<div><strong>Username: </strong>" + chosenUser.User.Username + "</div>") +
                        ("<div><strong>City: </strong>" + chosenUser.User.City + "</div>") +
                        ("<div><strong>Email: </strong>" + chosenUser.User.Email + "</div><br />") +
                        ("<div>Are you sure? Click the \"Add Now\" button to add this user as an " + levelName_1 + ", or click ") +
                        "the \"Cancel\" button to return to the search results.",
                    OKText: 'Add Now',
                    CancelText: 'Cancel',
                })
                    .subscribe(function (result) {
                    if (result === true) {
                        // User opted to proceed.
                        self.appService
                            .AddCollegeStaffToCollege(self.User.AuthToken, chosenUser.User.UserID, self.AdminCollege.CollegeID, chosenUser.AccessLevel)
                            .subscribe(function (staff) {
                            // Update the list of known staff
                            self.UpdateStaff(staff);
                            // Toast the success
                            self.splashService.SnackbarSuccess("User added as " + levelName_1 + " successfully.");
                        }, function (error) {
                            self.errorService.HandleServiceError(error);
                        });
                    }
                });
            }
        });
    };
    // #endregion
    // #region Sort Staff Method
    ManageStaffComponent.prototype.SortStaff = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'LastName':
                _a = [First.LastName, Second.LastName], PropA = _a[0], PropB = _a[1];
                break;
            case 'FirstName':
                _b = [First.FirstName, Second.FirstName], PropA = _b[0], PropB = _b[1];
                break;
            case 'AccessLevel':
                _c = [First.AccessLevel, Second.AccessLevel], PropA = _c[0], PropB = _c[1];
                break;
        }
        var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
        var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
        return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        var _a, _b, _c;
    };
    // #endregion
    // #region Update Staff Method
    ManageStaffComponent.prototype.UpdateStaff = function (staff) {
        var self = this;
        self.StaffList = staff || [];
        if (!self.StaffList || !self.StaffList.length) {
            self.NoData = true;
            // Put in a fake record to trip the display message
            self.StaffData.Update([{}]);
        }
        else {
            self.NoData = false;
            self.StaffData.Update(self.StaffList);
        }
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
    };
    return ManageStaffComponent;
}());
export { ManageStaffComponent };
// #region Custom Classes
// #region New User Info Class
var NewUserInfo = /** @class */ (function () {
    function NewUserInfo() {
    }
    return NewUserInfo;
}());
export { NewUserInfo };
// #endregion
// #region Parent Error State Matcher Class
var ParentErrorStateMatcher = /** @class */ (function () {
    function ParentErrorStateMatcher() {
    }
    ParentErrorStateMatcher.prototype.isErrorState = function (control, form) {
        var isSubmitted = !!(form && form.submitted);
        var controlTouched = !!(control && (control.dirty || control.touched));
        var controlInvalid = !!(control && control.invalid);
        var parentInvalid = !!(control &&
            control.parent &&
            control.parent.invalid &&
            (control.parent.dirty || control.parent.touched));
        return isSubmitted || (controlTouched && (controlInvalid || parentInvalid));
    };
    return ParentErrorStateMatcher;
}());
export { ParentErrorStateMatcher };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/app/managestaff/managestaff.component.ts.pre-build-optimizer.js